import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1 className="text-center text-danger">Sorry 404 error !!</h1>
        </div>
    );
};

export default NoMatch;